import type { ColorMode } from '@chukua/common';

/** What the user picked. `system` follows the OS and changes live with it. */
export type ColorModePreference = ColorMode | 'system';

export const COLOR_MODE_PREFERENCES: readonly ColorModePreference[] = ['light', 'dark', 'system'];

/**
 * localStorage key. Also read by the pre-paint script vite.config.ts injects
 * into index.html, so a dark-mode user never sees a white flash on load.
 */
export const COLOR_MODE_STORAGE_KEY = 'chukua.color-mode';

export const DARK_QUERY = '(prefers-color-scheme: dark)';

export function resolveColorMode(preference: ColorModePreference, systemPrefersDark: boolean): ColorMode {
  if (preference === 'system') return systemPrefersDark ? 'dark' : 'light';
  return preference;
}

/** Per-browser convenience only: storage may be unavailable (private mode, blocked). */
export function readPreference(storage: Pick<Storage, 'getItem'> | undefined): ColorModePreference {
  try {
    const value = storage?.getItem(COLOR_MODE_STORAGE_KEY);
    return COLOR_MODE_PREFERENCES.includes(value as ColorModePreference) ? (value as ColorModePreference) : 'system';
  } catch {
    return 'system';
  }
}

export function writePreference(storage: Pick<Storage, 'setItem'> | undefined, preference: ColorModePreference): void {
  try {
    storage?.setItem(COLOR_MODE_STORAGE_KEY, preference);
  } catch {
    // Not persisted; the choice still applies for this session.
  }
}
